import { Trans } from "@lingui/react/macro";
import type { ReactNode } from "react";

interface LabelProps {
    label: ReactNode;
    placeholder?: string;
}

export const cardNumberLabel = {
    label: <Trans>Card number</Trans>,
    // https://ux.stackexchange.com/questions/106902/credit-card-field-placeholder-text
    // placeholder: "4242 4242 4242 4242",
} as const satisfies LabelProps;

export const cardExpiryLabel = {
    label: <Trans>Valid thru</Trans>,
    placeholder: "MM/YY",
} as const satisfies LabelProps;

export const cardCvcLabel = {
    label: <Trans>CVC</Trans>,
    placeholder: "123",
} as const satisfies LabelProps;
